import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { SketchPicker } from 'react-color';

const GlobalSettings = ({ onUpdateGlobalSetting }) => {
    const [backgroundColor, setBackgroundColor] = useState('#ffffff');

    const handleChangeBackgroundColor = (color) => {
        setBackgroundColor(color.hex);
        onUpdateGlobalSetting({ backgroundColor: color.hex })
    };
    return (
        <Box  sx={{ padding: '16px' }}>
            <Typography variant="h6">Global Settings</Typography>
            <Typography variant="body1">Background Color</Typography>
            <SketchPicker color={backgroundColor} onChange={handleChangeBackgroundColor} />
         </Box>
    );
};

export default GlobalSettings;